import { createSelector } from 'reselect';
import { REDUX_ASYNC_STATUSES, ONBOARDING_STEPS } from '../../consts/consts';
import { selectCurrentUser } from '../authentication/selectors';
import { isHiddenOqioUser } from '../../helpers/utility';

const KNOWN_ACTIVE_ONBOARDING_STEPS = new Set(
  Object.values(ONBOARDING_STEPS).filter((s) => s !== ONBOARDING_STEPS.COMPLETED)
);

const isLoadingSelector = (statusKey) => (state) => state.config[statusKey] === REDUX_ASYNC_STATUSES.LOADING;

export const selectConfig = (state) => state.config?.config;
export const selectConfigLoading = isLoadingSelector('getConfigStatus');
export const selectUpdateConfigLoading = isLoadingSelector('updateConfigStatus');

// available is the backend gate and overrides the tenant switch
export const selectIsAiAssistantEnabled = (state) =>
  Boolean(state.config?.config?.ai_assistant_available && state.config?.config?.ai_assistant_enabled);

export const selectActivePrivacyStatementUrl = createSelector([selectConfig], (config) => {
  return config?.privacy_statement?.url ?? config?.privacy_statement_default_url ?? '#';
});

export const selectActiveTermsOfUseUrl = createSelector([selectConfig], (config) => {
  return config?.terms_of_use?.url ?? config?.terms_of_use_default_url ?? '#';
});

export const selectConfigOnboardingStep = (state) => state.config?.config?.onboarding_current_step;

export const selectConfigOnboardingImportSource = (state) =>
  state.config?.config?.onboarding_selected_import_source ?? null;

export const selectConfigOnboardingImportDone = (state) => Boolean(state.config?.config?.onboarding_oqio_import_done);

export const selectShouldBlockAppForOnboarding = createSelector(
  [selectCurrentUser, selectConfig, selectConfigOnboardingStep],
  (currentUser, config, step) => {
    const isNotHiddenOqioUser = isHiddenOqioUser(currentUser) === false;
    const isKnownActiveStep = config !== null && KNOWN_ACTIVE_ONBOARDING_STEPS.has(step);

    return isNotHiddenOqioUser && isKnownActiveStep;
  }
);

export const selectCanEditOnboarding = createSelector(
  [selectCurrentUser, selectShouldBlockAppForOnboarding],
  (currentUser, shouldBlockAppForOnboarding) => {
    const isAdmin = currentUser?.role === 'admin';

    return shouldBlockAppForOnboarding && isAdmin;
  }
);
